module.exports = __webpack_public_path__ + "static/media/poolday.6fe02565.jpg";